module.exports = __webpack_public_path__ + "static/media/left-quote.432e9b36.svg";